import { render } from "./lightbox_gallery.vue?vue&type=template&id=1aa1852e"
import script from "./lightbox_gallery.vue?vue&type=script&lang=js"
export * from "./lightbox_gallery.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__